import { CandlestickChart, ShieldCheck, Target } from "lucide-react";
import { ONLINE_ROADMAP, MARKETS } from "@/lib/content";
import { Reveal, SectionLabel } from "@/components/landing/Reveal";

const icons = [CandlestickChart, ShieldCheck, Target];

export const OnlineRoadmap = () => (
  <section className="relative overflow-hidden px-4 py-16 sm:px-8 lg:py-24" data-testid="online-roadmap-section">
    <div className="pointer-events-none absolute left-1/2 top-10 h-64 w-[36rem] -translate-x-1/2 rounded-full bg-em1/10 blur-[110px]" />
    <div className="relative z-10 mx-auto max-w-6xl">
      <Reveal className="max-w-3xl">
        <SectionLabel>The Roadmap</SectionLabel>
        <h2 className="mt-4 font-display text-5xl font-bold uppercase leading-[0.95] tracking-tight text-offwhite sm:text-6xl">
          Your Plan + 10 Planned Live Trades{" "}
          <span className="text-em2">by Day 90</span>
        </h2>
      </Reveal>

      <div className="mt-10 grid gap-4 md:grid-cols-3">
        {ONLINE_ROADMAP.map((r, i) => {
          const Icon = icons[i];
          return (
            <Reveal key={r.days} delay={i * 0.08}>
              <div className="card-surface group relative h-full overflow-hidden rounded-2xl p-6 sm:p-7">
                <span className="pointer-events-none absolute -right-3 -top-6 font-display text-7xl font-bold text-surfaceline/60">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-em2/25 bg-em1/10 text-em2 transition-transform duration-300 group-hover:scale-110">
                  <Icon size={26} strokeWidth={1.6} />
                </div>
                <p className="mt-5 text-xs font-bold uppercase tracking-[0.24em] text-gold">
                  {r.days}
                </p>
                <h3 className="mt-1.5 font-heading text-xl font-bold uppercase text-offwhite">
                  {r.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-mutedgreen">{r.body}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={0.15}>
        <div className="mt-8 flex flex-col items-start gap-4 rounded-2xl border border-surfaceline bg-surface p-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-gold">
            Markets Covered
          </p>
          <div className="flex flex-wrap gap-2.5">
            {MARKETS.map((m) => (
              <span
                key={m}
                className="rounded-full border border-em2/30 bg-em2/10 px-4 py-2 text-sm font-semibold text-em2"
              >
                {m}
              </span>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
